module.exports = __webpack_public_path__ + "static/img/Robert-Toia.8697834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Robert-Toia.jpg
// module id = Si3A
// module chunks = 0